import styled from 'styled-components';
import { css, breakpoints } from 'src/styles/theme';
import { Pages } from 'src/types/pages';
import { SummaryDealerDetailsStyled } from '../SummaryDealerDetailsStyled';
import { rem } from 'polished';

export const SummaryDealerDetailsDS = styled(SummaryDealerDetailsStyled)`
    border-bottom: ${rem('1px')} solid ${({ theme }) => theme.colors.secondary};
    border-top: ${rem('1px')} solid ${({ theme }) => theme.colors.secondary};

    .infoIcon {
        svg g {
            circle {
                stroke: ${({ theme }) => theme.colors.black};
            }

            line {
                stroke: ${({ theme }) => theme.colors.black};
            }
        }
    }

    .titleWrapper {
        .title {
            color: ${({ theme }) => theme.colors.black};
        }

        .isOpen {
            svg {
                path {
                    stroke: ${({ theme }) => theme.colors.black};
                }
            }
        }

        .isClose {
            svg {
                path {
                    fill: ${({ theme }) => theme.colors.black};
                }
            }
        }
    }

    .Collapsible__contentInner {
        .container {
            .info {
                color: ${({ theme }) => theme.colors.black};

                .addr,
                .item {
                    font-size: ${rem('14px')};
                }
            }
        }
    }

    .linkButton {
        border: unset;
        text-align: left;
        padding: unset;
        font-weight: bold;
        font-size: ${rem('14px')};
        margin-top: ${rem('16px')};
        color: black;
        background: unset;
        cursor: pointer;

        .txt {
            margin-right: ${rem('7px')};
        }

        .icon-wrapper {
            svg path {
                fill: black !important;
                stroke: black !important;
            }
        }

        &:hover {
            color: ${({ theme }) => theme.colors.primary};

            .icon-wrapper {
                svg path {
                    fill: ${({ theme }) => theme.colors.primary} !important;
                    stroke: ${({ theme }) => theme.colors.primary} !important;
                }
            }
        }
    }
`;
